import { Base, createApp } from '@studiometa/js-toolkit';
import { Action } from '@studiometa/ui';
import 'liquid-ajax-cart';
import Shop from './components/Shop/index.js';
import Sections from './components/Sections/index.js';
import Animations from './components/Animations/index.js';

/**
 * App
 */
class App extends Base {
  /**
   * App Configuration
   */
  static config = {
    name: 'App',
    components: {
      Action,
      Shop,
      Sections,
      '[data-animated]': Animations,
    },
  };
}

export default createApp(App, document.documentElement);
